/**
 * BIBAL Home Experience - JavaScript
 */
document.addEventListener('DOMContentLoaded', () => {
  const homeSection = document.querySelector('.bibal-home');
  if (!homeSection) return;

  // ==========================================================================
  // Persona Tabs
  // ==========================================================================
  const tabs = Array.from(homeSection.querySelectorAll('[data-persona-tab]'));
  const panels = Array.from(homeSection.querySelectorAll('[data-persona-panel]'));

  if (tabs.length && panels.length) {
    const activatePersona = (persona) => {
      tabs.forEach((tab) => {
        const isActive = tab.dataset.personaTab === persona;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
      });

      panels.forEach((panel) => {
        const isActive = panel.dataset.personaPanel === persona;
        panel.classList.toggle('is-active', isActive);
        panel.setAttribute('aria-hidden', String(!isActive));
        panel.hidden = !isActive;
      });
    };

    // Set initial state
    const defaultTab = tabs.find((tab) => tab.dataset.personaDefault === 'true') || tabs[0];
    if (defaultTab) {
      activatePersona(defaultTab.dataset.personaTab);
    }

    // Tab click handlers
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        activatePersona(tab.dataset.personaTab);
      });

      // Keyboard navigation
      tab.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          activatePersona(tab.dataset.personaTab);
        }

        // Arrow key navigation
        const currentIndex = tabs.indexOf(tab);
        let newIndex;

        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          newIndex = (currentIndex + 1) % tabs.length;
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        }

        if (newIndex !== undefined) {
          tabs[newIndex].focus();
          activatePersona(tabs[newIndex].dataset.personaTab);
        }
      });
    });
  }

  // ==========================================================================
  // Drag to Scroll (Desktop only - touch uses native scroll)
  // ==========================================================================
  const scrollTracks = homeSection.querySelectorAll(
    '.bibal-home__hero-track, .bibal-home__scroll-track'
  );

  scrollTracks.forEach((track) => {
    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;

    // Mouse events only (for desktop drag-to-scroll)
    track.addEventListener('mousedown', (e) => {
      isDown = true;
      track.classList.add('is-grabbing');
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    });

    track.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - track.offsetLeft;
      const walk = (x - startX) * 1.2;
      track.scrollLeft = scrollLeft - walk;
    });

    track.addEventListener('mouseup', () => {
      isDown = false;
      track.classList.remove('is-grabbing');
    });

    track.addEventListener('mouseleave', () => {
      isDown = false;
      track.classList.remove('is-grabbing');
    });

    // No touch events - let native scroll-snap handle mobile
  });

  // ==========================================================================
  // Coupon Carousel - Copy to Clipboard & Reveal
  // ==========================================================================
  const couponCards = homeSection.querySelectorAll('.bibal-home__coupon-card');
  const displayMode = homeSection.querySelector('.bibal-home__coupons')?.dataset.displayMode || 'reveal';

  couponCards.forEach((card) => {
    const code = card.dataset.couponCode;
    if (!code) return;

    const handleCouponClick = async () => {
      // In reveal mode, first click reveals, subsequent clicks copy
      if (displayMode === 'reveal' && !card.classList.contains('is-revealed')) {
        card.classList.add('is-revealed');
        return;
      }

      // Copy to clipboard
      try {
        await navigator.clipboard.writeText(code);

        // Show copied feedback
        card.classList.add('is-copied');

        // Remove feedback after animation
        setTimeout(() => {
          card.classList.remove('is-copied');
        }, 2000);
      } catch (err) {
        // Fallback for older browsers
        const textarea = document.createElement('textarea');
        textarea.value = code;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();

        try {
          document.execCommand('copy');
          card.classList.add('is-copied');
          setTimeout(() => {
            card.classList.remove('is-copied');
          }, 2000);
        } catch (fallbackErr) {
          console.error('Failed to copy:', fallbackErr);
        }

        document.body.removeChild(textarea);
      }
    };

    // Click and keyboard events
    card.addEventListener('click', handleCouponClick);

    card.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        handleCouponClick();
      }
    });
  });
});
